// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ff46fb54","container":"d6d298ee","topSpacer":"a921874a","iframe":"cfa12645"};